import React from "react"
import { Link } from "react-router-dom"
const WhyChooseUsSection = () => {
  const whyChooseUsData = [
    {
      id: 1,
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M9 12l2 2 4-4" />
          <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z" />
        </svg>
      ),
      title: "Proven Track Record",
      description: "Over 500+ successful campaigns delivered with measurable results and client satisfaction.",
      metric: "500+",
      label: "Campaigns",
      color: "#6366f1",
      gradient: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
    },
    {
      id: 2,
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      ),
      title: "Client-Centric Approach",
      description: "We tailor every strategy to your unique goals and business requirements.",
      metric: "100%",
      label: "Customized",
      color: "#ec4899",
      gradient: "linear-gradient(135deg, #ec4899 0%, #f97316 100%)",
    },
    {
      id: 3,
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polygon points="13,2 3,14 12,14 11,22 21,10 12,10 13,2" />
        </svg>
      ),
      title: "Expert Team",
      description: "Specialists in SEO, PPC, social media, and content marketing strategies.",
      metric: "50+",
      label: "Experts",
      color: "#06b6d4",
      gradient: "linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%)",
    },
    {
      id: 4,
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="18" y1="20" x2="18" y2="10" />
          <line x1="12" y1="20" x2="12" y2="4" />
          <line x1="6" y1="20" x2="6" y2="14" />
        </svg>
      ),
      title: "Transparent Reporting",
      description: "Know exactly where your money is going with detailed analytics and reports.",
      metric: "100%",
      label: "Transparency",
      color: "#10b981",
      gradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    },
    {
      id: 5,
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <polyline points="12,6 12,12 16,14" />
        </svg>
      ),
      title: "Faster Results",
      description: "Start seeing growth within the first month with our proven methodologies.",
      metric: "30",
      label: "Days",
      color: "#f59e0b",
      gradient: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
    },
    {
      id: 6,
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      ),
      title: "24/7 Support",
      description: "Our dedicated team is always ready to assist you whenever you need help.",
      metric: "24/7",
      label: "Available",
      color: "#8b5cf6",
      gradient: "linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%)",
    },
  ]

  return (
    <section
      className="py-5"
      style={{
        // background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
        minHeight: "60vh",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background Decorative Elements */}
      <div
        style={{
          position: "absolute",
          top: "-50px",
          right: "-50px",
          width: "200px",
          height: "200px",
          background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
          borderRadius: "50%",
          opacity: "0.1",
          filter: "blur(40px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "-100px",
          left: "-100px",
          width: "300px",
          height: "300px",
          background: "linear-gradient(135deg, #ec4899, #f97316)",
          borderRadius: "50%",
          opacity: "0.1",
          filter: "blur(60px)",
        }}
      />

      <div className="container position-relative">
        {/* Section Header */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-8 text-center">
            <div className="mb-3">
              <span
                className="badge px-4 py-2"
                style={{
                  background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
                  color: "white",
                  borderRadius: "50px",
                  fontSize: "14px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  boxShadow: "0 4px 15px rgba(99, 102, 241, 0.3)",
                }}
              >
                ✨ Why Choose Us
              </span>
            </div>
            <h2
              className="display-4 fw-bold"
              style={{
                color: "#1e293b",
                letterSpacing: "-1px",
                lineHeight: "1",
                fontSize : "40px"
              }}
            >
              Why Businesses Trust Us
            </h2>
            <p
              className="lead text-muted"
              style={{
                maxWidth: "800px",
                margin: "0 auto",
                fontSize: "1.5rem",
                lineHeight: "1.6",
              }}
            >
              Discover what sets us apart and makes us the preferred choice for digital marketing success
            </p>
          </div>
        </div>

        {/* Cards Grid */}
        <div className="row g-4">
          {whyChooseUsData.map((item, index) => (
            <div key={item.id} className="col-lg-4 col-md-6">
              <div
                className="h-100 position-relative"
                style={{
                  background: "rgba(255, 255, 255, 0.8)",
                  backdropFilter: "blur(10px)",
                  borderRadius: "24px",
                  padding: "2rem",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  cursor: "pointer",
                  overflow: "hidden",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px) scale(1.02)"
                  e.currentTarget.style.boxShadow = "0 20px 40px rgba(0, 0, 0, 0.15)"
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0) scale(1)"
                  e.currentTarget.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.1)"
                }}
              >
                {/* Background Pattern */}
                <div
                  style={{
                    position: "absolute",
                    top: "-20px",
                    right: "-20px",
                    width: "100px",
                    height: "100px",
                    background: item.gradient,
                    borderRadius: "50%",
                    opacity: "0.1",
                    filter: "blur(20px)",
                  }}
                />

                {/* Icon Container */}
                <div className="mb-4">
                  <div
                    className="d-inline-flex align-items-center justify-content-center"
                    style={{
                      width: "70px",
                      height: "70px",
                      background: item.gradient,
                      borderRadius: "20px",
                      color: "white",
                      boxShadow: `0 8px 25px ${item.color}40`,
                      transition: "all 0.3s ease",
                    }}
                  >
                    {item.icon}
                  </div>
                </div>

                {/* Content */}
                <div className="mb-4">
                  <h4
                    className="fw-bold mb-3"
                    style={{
                      color: "#1e293b",
                      fontSize: "2rem",
                      lineHeight: "1.3",
                    }}
                  >
                    {item.title}
                  </h4>
                  <p
                    className="text-muted mb-0"
                    style={{
                      fontSize: "1.5rem",
                      lineHeight: "1.6",
                    }}
                  >
                    {item.description}
                  </p>
                </div>

                {/* Metric Section */}
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h3
                      className="fw-bold mb-1"
                      style={{
                        color: item.color,
                        fontSize: "2.2rem",
                        lineHeight: "1",
                      }}
                    >
                      {item.metric}
                    </h3>
                    <span
                      className="badge"
                      style={{
                        background: `${item.color}15`,
                        color: item.color,
                        borderRadius: "12px",
                        fontSize: "1rem",
                        fontWeight: "600",
                        padding: "0.4rem 0.8rem",
                      }}
                    >
                      {item.label}
                    </span>
                  </div>

                  {/* Progress Ring */}
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      background: `conic-gradient(${item.color} 0deg, ${item.color} 270deg, #e2e8f0 270deg)`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        width: "35px",
                        height: "35px",
                        borderRadius: "50%",
                        background: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          background: item.color,
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Bottom Accent Line */}
                <div
                  style={{
                    position: "absolute",
                    bottom: "0",
                    left: "0",
                    right: "0",
                    height: "4px",
                    background: item.gradient,
                    borderRadius: "0 0 24px 24px",
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA Section */}
        <div className="row justify-content-center mt-5 pt-4">
          <div className="col-lg-6 text-center">
            <div
              className="p-4"
              style={{
                background: "rgba(255, 255, 255, 0.6)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px",
                border: "1px solid rgba(255, 255, 255, 0.3)",
              }}
            >
              <h5 className="fw-bold mb-3" style={{ color: "#1e293b" }}>
                Ready to Get Started?
              </h5>
              <p className="text-muted mb-3">
                Join hundreds of satisfied clients who trust us with their digital marketing needs.
              </p>
              <button
                className="btn btn-lg px-4 py-2"
                style={{
                  background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
                  border: "none",
                  borderRadius: "50px",
                  color: "white",
                  fontWeight: "600",
                  boxShadow: "0 4px 15px rgba(99, 102, 241, 0.3)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)"
                  e.currentTarget.style.boxShadow = "0 8px 25px rgba(99, 102, 241, 0.4)"
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)"
                  e.currentTarget.style.boxShadow = "0 4px 15px rgba(99, 102, 241, 0.3)"
                }}
              ><Link to="/contact">
                Get Started Today
                </Link>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WhyChooseUsSection
